shadow$provide[13] = function(global,require,module,exports) {
// Generated by genversion.
module.exports = '1.42.3'

};